import {Box, Grid, Typography} from "@material-ui/core";
import {helpFormReasons} from "../../configs/complianceReasons";
import {IHelpFormReasons} from "../../interfaces/assistanceContext";
import {InputMessage} from "./Fields/InputMessage";
import React from "react";
import {useTranslation} from "react-i18next";

export const UserDataHelp = (props: any) => {

    const {t} = useTranslation();

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Box mt={5}>
                    <Typography component={'h5'} variant={'h5'}>{t('inserisci_dati')}</Typography>
                </Box>
            </Grid>

            {
                helpFormReasons.map((reason: IHelpFormReasons, index: number) =>
                    reason.radioList.filter((list: any) => props.argument === list.title).map((f: any) => f.fields.map((value: any, newIndex: number) => (
                            <Grid item xs={12} sm={6} key={newIndex}>
                                {value}
                            </Grid>
                        ))
                    ))
            }

            <InputMessage />
        </Grid>
    )
};
